import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";

export const SignoutStaffMetaFields = {
  signoutId: propertyMeta("signoutId", false, true, false, MetaTypesBase.number),
  cardNum: propertyMeta("cardNum", false, false, false, MetaTypesBase.string),
  sailNumber: propertyMeta("sailNumber", false, false, false, MetaTypesBase.string),
  hullNumber: propertyMeta("hullNumber", false, false, false, MetaTypesBase.string),
  signoutDatetime: propertyMeta("signoutDatetime", false, false, false, MetaTypesBase.Date),
  signinDatetime: propertyMeta("signinDatetime", false, false, false, MetaTypesBase.Date),
  testResult: propertyMeta("testResult", false, false, false, MetaTypesBase.string),
  signoutType: propertyMeta("signoutType", false, true, false, MetaTypesBase.string),
  didCapsize: propertyMeta("didCapsize", false, false, false, MetaTypesBase.boolean),
  isQueued: propertyMeta("isQueued", false, true, false, MetaTypesBase.boolean),
  queueOrder: propertyMeta("queueOrder", false, false, false, MetaTypesBase.number),
  comments: propertyMeta("comments", false, false, false, MetaTypesBase.string),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
  skipperId: propertyMeta("skipperId", false, false, false, MetaTypesBase.number),
  skipperName: propertyMeta("skipperName", false, false, false, MetaTypesBase.string),
  programName: propertyMeta("programName", false, false, false, MetaTypesBase.string),
  boatName: propertyMeta("boatName", false, false, false, MetaTypesBase.string),
};

export const SignoutStaffMeta = typeMeta("SignoutStaff", SignoutStaffMetaFields);
